const fixedColumns = [
  "statuses",
  "tags",
  "allocations",
  "allocated",
  "startDate",
  "endDate",
  "completionDate",
];

export { fixedColumns };
